import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import React from 'react';
import styles from './main-loading-style';

interface GlobalLoaderProps extends WithStyles {
    center?: boolean;
    startLoadingTimeout?: number;
    loaderProps?: CircularProgressProps;
}

function GlobalLoader(props: GlobalLoaderProps) {
    const { startLoadingTimeout = 250, classes, center, loaderProps } = props;

    const [isDisplaying, setDisplay] = React.useState<boolean>(false);

    React.useEffect(() => {
        const startTimeout: NodeJS.Timeout = setTimeout(() => setDisplay(true), startLoadingTimeout);

        return () => {
            clearTimeout(startTimeout);
        };
    }, [startLoadingTimeout]);

    if (isDisplaying) {
        return (
            <div className={center ? classes.center : classes.root}>
                <CircularProgress size={60} {...loaderProps} />
            </div>
        );
    }
    return null;
}

export default withStyles(styles)(GlobalLoader);
